import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePlatform, usePlatformDispatch, PLATFORM_RESET } from "../PlatformContext";
import { logoutUser } from "@shared/features/auth/utils/logoutUser";

/**
 * Hook to close platform access - logs out any logged-in user and redirects to home page
 * Only runs if isPlatformClosed is true
 */
export function useClosePlatformAccess() {
  const { user, isPlatformClosed } = usePlatform();
  const dispatch = usePlatformDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isPlatformClosed) return;

    const handleLogout = async () => {
      if (user) {
        try {
          await logoutUser();
          dispatch({ type: PLATFORM_RESET });
        } catch (error) {
          console.error("Error logging out:", error);
        }
      }
      // Redirect to home page whether logged in or not
      navigate("/", { replace: true });
    };

    handleLogout();
  }, [user, dispatch, navigate, isPlatformClosed]);
}

export default useClosePlatformAccess;

